import React, { useState, useEffect, useCallback } from "react";
import { Label, Spinner } from "flowbite-react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";
import Mousetrap from "mousetrap";

import "./Create.css";

const backend = await new Backend().init();

export default function Create({ master_id, userType }) {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [name, setName] = useState("");

  const onCreate = useCallback(async () => {
    if (!username.trim() || !name.trim()) {
      toast.error("Please fill out both Username and Name.");
      return;
    }

    setLoading(true);
    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      master_id: userType === 3 ? localStorage.getItem("id") : master_id,
      user_username: username,
      user_name: name,
    };

    try {
      const r = await backend.create_user(data);
      if (r.error === "False") {
        toast.success(r.message);
        setUsername("");
        setName("");
      } else {
        toast.error(r.message);
      }
    } catch (error) {
      console.error("Create user failed:", error);
      toast.error("Something went wrong, please try again.");
    } finally {
      setLoading(false);
    }
  }, [username, name, master_id, userType]);

  // --- Keyboard shortcut: Press Enter to submit ---
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      onCreate();
    };

    Mousetrap.bind("enter", handler);
    return () => Mousetrap.unbind("enter", handler);
  }, [onCreate]);

  return (
    <div className="createUser">
      {/* Username */}
      <div className="username">
        <Label className="label" value="Username" />
        <input
          type="text"
          id="username"
          placeholder="Enter Username"
          aria-label="Enter username"
          className="input hover-background bg-gray-50 border h-8 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </div>

      {/* Name */}
      <div className="name" style={{ marginTop: 15 }}>
        <Label className="label" value="Name" />
        <input
          type="text"
          id="name"
          placeholder="Enter Name"
          aria-label="Enter full name"
          className="input hover-background bg-gray-50 border h-8 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      {/* Submit */}
      <div onClick={onCreate} className="btnSubmit" role="button" tabIndex={0}>
        {loading ? <Spinner size="sm" /> : "Submit"}
      </div>
    </div>
  );
}
